import React from 'react';
import CommonLayoutPresenter from './CommonLayoutPresenter';
import GnbTabs from './GnbTabs';
import GnbExtraBtn from './GnbExtraBtn';

interface Props {
  gnbTabs?: React.ReactNode;
  gnbExtraBtn?: React.ReactNode;
  leftSideDrawer?: React.ReactNode;
  contentShift?: boolean;
  rightSideDrawer?: React.ReactNode;
  bottomNav?: React.ReactNode;
  isChatDetail?: boolean;
  fullHeight?: boolean;
}

const CommonLayoutContainer: React.FC<Props> = ({
  gnbTabs,
  gnbExtraBtn,
  leftSideDrawer,
  contentShift,
  rightSideDrawer,
  bottomNav,
  children,
  isChatDetail,
  fullHeight
}) => {
  return (
    <CommonLayoutPresenter
      gnbTabs={gnbTabs ? gnbTabs : <GnbTabs />}
      extraBtn={gnbExtraBtn ? gnbExtraBtn : <GnbExtraBtn />}
      contentShift={contentShift}
      leftSideDrawer={leftSideDrawer}
      rightSideDrawer={rightSideDrawer}
      bottomNav={bottomNav}
      isChatDetail={isChatDetail}
      fullHeight={fullHeight}
    >
      {children}
    </CommonLayoutPresenter>
  );
};

export default CommonLayoutContainer;
